import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreatmentCenterDetailsPageComponent } from './components/treatment-center-details-page/treatment-center-details-page.component';
import { TreatmentCenterDetailsComponent } from './components/treatment-center-details/treatment-center-details.component';
import { TranslateModule } from '@ngx-translate/core';

import { PartnerModule } from '../partner/partner.module';
import { UsersModule } from '../user/users.module';

import { DetailsCommonsModule } from '@shared/modules/details-commons/details-commons.module';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';

@NgModule({
  imports: [
    CommonModule,
    DetailsCommonsModule,
    FontAwesomeModule,
    GeneralCommonsModule,
    PartnerModule,
    TranslateModule.forChild(),
    UsersModule,
    TreatmentCenterDetailsPageComponent,
    TreatmentCenterDetailsComponent
  ]
})
export class TreatmentCenterModule {}
